import { s as state } from './state-3cc1e9a3.js';

/**
 * Returns a random ID compose of character and strings at a specified length
 *
 * @param {number} length
 * @returns {string}
 */
function randomId(length) {
  // Set random ID as variable
  let generatedRandomId = '';
  // Set character map as constant
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
  // Loop from zero to the length of the chosen random ID
  for (let i = 0; i < length; i += 1) {
    // Append a random character to the random ID
    generatedRandomId += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  // Return the random ID
  return generatedRandomId;
}
/**
 * Capitalises the first letter of a string
 *
 * @param {string} string
 * @returns {string}
 */
function capitalise(string = '') {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
/**
 * Retrieves a search query parameter from the URL
 *
 * @param {string} parameter
 * @returns {string}
 */
function getSearchParameter(queryParameter, defaultValue) {
  // Retrieve search parameters from URL
  const searchParameters = new URLSearchParams(window.location.search);
  // Return based on whether the parameter exists, otherwise return the default value
  return searchParameters.has(queryParameter) ? searchParameters.get(queryParameter) : defaultValue;
}
function buildSearchParameters() {
  // Create new URL for storing search query parameters
  const searchParameters = {};
  // Retrieve search query
  searchParameters['q'] = state.query;
  // Loop post filters
  for (let field in state.postFilters) {
    const values = state.postFilters[field];
    if (values.length > 0) {
      searchParameters[`filter${field}`] = values.join(',');
    }
  }
  // Loop range filters
  for (let field in state.ranges) {
    const value = state.ranges[field];
    if (value) {
      searchParameters[`range${field}`] = value;
    }
  }
  // Retrieve sort
  const selectedSort = state.sorts.find(sort => sort.selected);
  if (selectedSort) {
    searchParameters['sort'] = `${selectedSort.name}${capitalise(selectedSort.value)}`;
  }
  return searchParameters;
}
/**
 * Returns the field value from the search result
 *
 * @param {object} fields
 * @param {string} fieldName
 * @param {string} defaultValue
 * @param {boolean} returnHighlights
 * @returns {string}
 */
function getFieldValue(fields, fieldName, defaultValue = 'Unknown', returnHighlights = false) {
  // Assign field to a constant
  const field = fields[fieldName];
  // Verify that the field exists
  if (field) {
    // Assign field value to variable so it can be trimmed
    let fieldValue = field.Value;
    // Trim field value at 200 characters
    if (fieldValue.length > 200) {
      fieldValue = fieldValue.substring(0, 200);
    }
    // Initialise field higlights with trimmed field value
    let fieldHighlights = fieldValue;
    // Verify that highlights exist on this field
    if (field.Highlights && field.Highlights.length > 0) {
      // Update field higlights to the first highlight only 
      fieldHighlights = field.Highlights.join(' ');
    }
    // Return trimmed field value or joined highlights
    return returnHighlights ? fieldHighlights : fieldValue;
  }
  // The field does not exist, return the default string
  return defaultValue;
}

export { getSearchParameter as a, buildSearchParameters as b, capitalise as c, getFieldValue as g, randomId as r };
